"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateUnderwritingReviewUpdate = exports.underwritingReviewUpdateSchema = void 0;
var schema_validator_1 = require("@hobt/schema-validator");
var underwriting_review_check_1 = require("./underwriting-review-check");
var underwriting_review_status_1 = require("./underwriting-review-status");
exports.underwritingReviewUpdateSchema = {
    type: 'object',
    required: ['check', 'cmhcLoanAccountNumber'],
    properties: {
        check: {
            type: 'integer',
            enum: Object.values(underwriting_review_check_1.UnderwritingReviewCheck),
            errorMessage: 'Should equate to a valid Check Enum value',
        },
        cmhcLoanAccountNumber: {
            type: 'integer',
            maximum: 99999999,
            minimum: 1000000,
            errorMessage: 'should be numeric between 1000000 to 99999999',
        },
        status: {
            type: 'integer',
            enum: Object.values(underwriting_review_status_1.UnderwritingReviewStatus),
            errorMessage: 'Should equate to a valid Status Enum value',
        },
    },
};
exports.validateUnderwritingReviewUpdate = function (data) {
    var underwritingReviewValidator = new schema_validator_1.SchemaValidator(exports.underwritingReviewUpdateSchema, true, true, true, true);
    return underwritingReviewValidator.validate(data);
};
